
import { ReactNode, useMemo } from 'react'
import { Entity, Hit, noHit } from './Entity.ts'
import { useDrawCall } from './hooks/useDrawCall.tsx'
import { useGL } from './hooks/useGL.ts'
import { useProgram } from './hooks/useProgram.ts'
import { Ray } from './VectorMath.ts'
import fragmentSource from './WorldAxes.fs?raw'
import vertexSource from './WorldAxes.vs?raw'

export class WorldAxes implements Entity {
  hitTest(_ray: Ray): Hit {
    return noHit
  }
}

export function WorldAxesView(props: {
  worldAxes: WorldAxes
  enabled: boolean
}): ReactNode {
  const { enabled } = props

  const gl = useGL()
  const program = useProgram('WorldAxes', gl, vertexSource, fragmentSource)
  const locations = useMemo(() => ({
    clipFromWorld: gl.getUniformLocation(program, 'u_clipFromWorld'),
  }), [gl, program])

  useDrawCall('WorldAxes', ({ gl, clipFromWorld }) => {
    if (!enabled) {
      return
    }

    gl.useProgram(program)
    gl.uniformMatrix4fv(locations.clipFromWorld, false, Float32Array.from(clipFromWorld))

    gl.disable(gl.DEPTH_TEST)

    // 3 axes, two directions, 2 vertices per direction
    gl.drawArrays(gl.LINES, 0, 3 * 2 * 2)

    gl.enable(gl.DEPTH_TEST)

    gl.useProgram(null)
  }, [gl, program, locations, enabled], { priority: 1 })

  return undefined
}
